import { AlkLogger } from '@alk/core';
import { injectable } from 'inversify';
import { IPersistenceAdapterService, ISettingsPartialRecord } from './persistence-adapter.interface';
import { Observable, of } from 'rxjs';
import { USER_SETTINGS } from '../../../mocks/user-settings.data';

@injectable()
export class PersistenceAdapterMock implements IPersistenceAdapterService {

    settingsObs = (): Observable<ISettingsPartialRecord> => of(USER_SETTINGS);

    save(): void{
        AlkLogger.debug('[PersistenceAdapterMock#save]');
    }
}
